import ClientGeneralForm from './ClientGeneralForm'

export * from './ClientGeneralForm'
export default ClientGeneralForm
